import * as Sentry from '@sentry/react';

let initialized = false;

/**
 * Initialize Sentry for the marketing website. No-op when REACT_APP_SENTRY_DSN is unset.
 */
export function initSentry(): void {
  if (initialized) return;

  const dsn = (process.env.REACT_APP_SENTRY_DSN || '').trim();
  if (!dsn) return;

  Sentry.init({
    dsn,
    environment: process.env.NODE_ENV || 'development',
    release: process.env.REACT_APP_SENTRY_RELEASE || undefined,
    tracesSampleRate: process.env.NODE_ENV === 'production' ? 0.1 : 0,
    sendDefaultPii: false,
    initialScope: {
      tags: { surface: 'website' },
    },
  });

  initialized = true;
}

export { Sentry };



// WEBPACK FOOTER //
// ./src/sentry.ts